import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function PriceBlock() {
  return <section id="precio" className="py-14 md:py-24 px-4 bg-white relative" data-id="element-125">
      <div className="max-w-5xl mx-auto" data-id="element-126">
        <div className="bg-cream rounded-[3rem] p-8 md:p-12 lg:p-16 shadow-xl relative overflow-hidden border-4 border-white outline outline-1 outline-cream/50" data-id="element-127">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-128">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-129">
              <h2 className="text-4xl md:text-5xl mb-6" data-id="element-130">
                Salvá tus muebles y dale una vida digna a tu compañero.
              </h2>
              <p className="text-xl md:text-2xl mb-8 text-warmBrown/80" data-id="element-131">
                Hoy podés llevarte la guía completa de{' '}
                <strong className="text-amber" data-id="element-132">Gato de Depto. Feliz</strong> por
                un precio menor al de una bolsa de alimento de 3kg.
              </p>

              <div className="mb-8" data-id="element-133">
                <span className="text-5xl md:text-6xl font-heading text-amber block mb-2" data-id="element-134">
                  $8.999 ARS
                </span>
                <span className="text-lg text-warmBrown/60 font-medium" data-id="element-135">
                  Pago único. Acceso de por vida.
                </span>
              </div>

              <Button className="w-full text-xl py-5 shadow-amber/30" data-id="element-136">
                QUIERO MI GUÍA AHORA
              </Button>

              <div className="mt-6 flex items-center justify-center gap-2 text-warmBrown/70 text-sm font-medium" data-id="element-137">
                <ShieldCheck size={18} className="text-sage" data-id="element-138" />
                <span data-id="element-139">
                  Pago seguro a través de Mercado Pago. Entrega inmediata a tu
                  email.
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative hidden lg:block" data-id="element-140">
              <div className="absolute inset-0 bg-amber/10 rounded-3xl transform -rotate-3 scale-105" data-id="element-141"></div>
              <img src="https://cdn.magicpatterns.com/uploads/sQS5QY5k9NqoGZMqxsiFZm/Mockup_3.png" alt="Guía Gato de Depto Feliz" className="relative z-10 w-full h-auto rounded-2xl shadow-lg" data-id="element-142" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}